import React, { useEffect, useState } from 'react';
import { getSecteurs, getPartenaires, getLocalites, getForages } from '../services/api';

const SecteursList: React.FC = () => {
  const [secteurs, setSecteurs] = useState<any[]>([]);
  const [partenaires, setPartenaires] = useState<any[]>([]);
  const [localites, setLocalites] = useState<any[]>([]);
  const [forages, setForages] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState<any>({});

  useEffect(() => {
    getPartenaires().then(r => setPartenaires(r.data)).catch(() => {});
    getLocalites({}).then(r => {
      const data = r.data.data || r.data;
      setLocalites(Array.isArray(data) ? data : []);
    }).catch(() => {});
    getForages().then(r => {
      const data = r.data.data || r.data;
      setForages(Array.isArray(data) ? data : []);
    }).catch(() => {});
  }, []);

  const updateFilter = (key: string, value: string) => {
    setFilters((prev: any) => ({ ...prev, [key]: value }));
    setPage(1);
  };

  useEffect(() => {
    const params: Record<string, string> = { page: page.toString(), limit: '30' };
    Object.entries(filters).forEach(([k, v]) => { if (v) params[k] = v as string; });
    getSecteurs(params).then(r => {
      if (r.data.data) {
        setSecteurs(r.data.data);
        setTotal(r.data.total || 0);
        setTotalPages(r.data.totalPages || 1);
      } else {
        setSecteurs(r.data);
        setTotal(r.data.length);
        setTotalPages(1);
      }
    }).catch(() => {});
  }, [page, filters]);

  // Filter localites by selected partenaire
  const filteredLocalites = filters.partenaire_id
    ? localites.filter(l => l.partenaire_id === filters.partenaire_id)
    : localites;

  // Filter forages by selected partenaire
  const filteredForages = filters.partenaire_id
    ? forages.filter((f: any) => f.partenaire_id === filters.partenaire_id)
    : forages;

  return (
    <div>
      <h2 style={{ marginBottom: 20, color: '#333' }}>Secteurs ({total.toLocaleString()})</h2>

      <div className="filters-bar">
        <select value={filters.partenaire_id || ''} onChange={e => updateFilter('partenaire_id', e.target.value)}>
          <option value="">Tous les partenaires</option>
          {partenaires.map(p => <option key={p.id} value={p.id}>{p.libelle}</option>)}
        </select>
        <select value={filters.localite_id || ''} onChange={e => updateFilter('localite_id', e.target.value)}>
          <option value="">Toutes les localites</option>
          {filteredLocalites.map((l: any) => <option key={l.id} value={l.id}>{l.libelle}</option>)}
        </select>
        <select value={filters.forage_id || ''} onChange={e => updateFilter('forage_id', e.target.value)}>
          <option value="">Tous les forages</option>
          {filteredForages.map((f: any) => <option key={f.id} value={f.id}>{f.libelle}</option>)}
        </select>
        {Object.values(filters).some(v => v) && (
          <button
            onClick={() => { setFilters({}); setPage(1); }}
            style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#ef5350', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}
          >
            Reinitialiser
          </button>
        )}
      </div>

      <div className="data-table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              <th>Libelle</th>
              <th>Localite</th>
              <th>Partenaire</th>
              <th>Forage</th>
            </tr>
          </thead>
          <tbody>
            {secteurs.map((s: any, i: number) => (
              <tr key={s.id || i}>
                <td><strong>{s.libelle}</strong></td>
                <td>{s.localite_nom || '-'}</td>
                <td>{s.partenaire || '-'}</td>
                <td>{s.forage || '-'}</td>
              </tr>
            ))}
            {secteurs.length === 0 && (
              <tr><td colSpan={4} style={{ textAlign: 'center', padding: 40, color: '#999' }}>Aucun secteur trouve</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button disabled={page <= 1} onClick={() => setPage(page - 1)}>Precedent</button>
        <span style={{ padding: '8px 14px', fontSize: 14 }}>Page {page} / {totalPages}</span>
        <button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Suivant</button>
      </div>
    </div>
  );
};

export default SecteursList;
